import './index.scss';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { ModalBase } from '../modals/modal-base';
import PropTypes from 'prop-types';
import { customizeErrorAlert } from '../../services/customize-error-alert-bar';


class SimpleMultipleEntryPopup extends Component {

    state = {
        isApplyBtnDisabled: true,
        multipleNumbers: ( this.props.propertyValue ).trim(),
    };


    onApplyValidation = () => {

        const selectedOption = {
            target: {
                name: this.props.propertyName,
                value: this.state.multipleNumbers,
            },
        };
        if ( this.props.onApplyValidate( selectedOption ) ) {

            this.onApply( selectedOption );

        } else {

            let message = `${this.props.panelName} number should be 13 or 17 digits`;
            if ( this.props.propertyName === 'partNumber' || this.props.propertyName === 'claimNumbers' ) message = `${this.props.panelName} number should be 12 digits`;
            if ( this.props.propertyName === 'pipNumbers' ) message = `${this.props.panelName} number should be 8 digits`;
            if ( this.props.propertyName === 'supplierId' ) message = `${this.props.panelName} number should be 10 digits`;
            if ( this.props.propertyName === 'modelCdList' ) message = `${this.props.panelName} number should be 5 digits`;
            customizeErrorAlert( message );

        }

    }

    onApply = event => {

        this.props.onUpdateProperty( event );
        this.onCancel();

    }

    onCancel = () => {

        this.props.onClose();

    }

    onReset = () => {

        this.setState( {
            multipleNumbers: this.props.propertyValue,
            isApplyBtnDisabled: true,
        } );

    }

    tarea = event => {

      //  if ( this.props.multiEntryValidation( event.target.value ) ) {

            this.setState( {
                isApplyBtnDisabled: this.props.propertyValue === event.target.value,
                multipleNumbers: event.target.value,
            } );

       // }


    }


    render () {


        return (
            <ModalBase
                body={(
                    <div className="flex-container">
                        <div>
                            <div>
                                <label>{this.props.panelName}</label>
                                <label> Number can be provided in one of the formats</label>

                            </div>

                            <div className="multiplebody">
                                <span className="multiplestyle">
                                    <label>Example:</label>
                                </span>
                                <span className="multiplestyle">
                                    {' '}
                                value1, value2
                                    <br />
                                </span>
                                <br />
                                <span className="multiplestyle style">
                                    {' '}
                                OR
                                    <br />
                                </span>
                                <span className="multiplestyle">
                                value1
                                    <br />
                                value2
                                    <br />
                                </span>
                            </div>
                        </div>
                        <div>


                            <textarea rows="10" name="multiNumber" value={this.state.multipleNumbers} onChange={this.tarea} />
                        </div>

                    </div>
                )}
                header={(
                    <div>
                        Multiple
                        {' '}
                        {this.props.panelName}
                        {' '}
                        Number Search
                        <i className="fa fa-times-circle-o pull-right" onClick={this.onCancel} aria-hidden="true" />
                    </div>
                )}
                onHide={this.handleConfirm}
                isOpen={this.props.isOpen}
                footer={(
                    <span>
                        <button className="close-button" type="button" onClick={this.onCancel.bind( this )}>
                            <FormattedMessage id="Cancel" />
                        </button>
                        <button className="reset-button" type="button" onClick={this.onReset}>
                            <FormattedMessage id="Reset" />
                        </button>
                        <button className="primary-button" type="button" disabled={this.state.isApplyBtnDisabled} onClick={this.onApplyValidation}>
                            <FormattedMessage id="Apply" />
                        </button>
                    </span>
                )}
                size=""
            />

        );

    }

}
SimpleMultipleEntryPopup.displayName = 'PopUpPanel';
SimpleMultipleEntryPopup.propTypes = {
    panelName: PropTypes.string.isRequired,
    propertyName: PropTypes.string.isRequired,
    propertyValue: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onUpdateProperty: PropTypes.func.isRequired,
    onApplyValidate: PropTypes.func.isRequired,
    isValidEntry: PropTypes.bool.isRequired,
    multiEntryValidation: PropTypes.func.isRequired,
};


export default SimpleMultipleEntryPopup;
